import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * 情報・ヘルプ用の丸い i アイコン
 */
export const InfoCircleIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <circle
            cx="12"
            cy="12"
            r="9"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <line
            x1="12"
            x2="12"
            y1="10.5"
            y2="17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <circle cx="12" cy="7" r="1.35" fill="currentColor" />
    </svg>
);
